import { render, staticRenderFns } from "./ReportParams.vue?vue&type=template&id=2ed56208"
import script from "./ReportParams.vue?vue&type=script&lang=js"
export * from "./ReportParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports